// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"d677bbbf","401":"27403853","583":"7f13dd24","637":"4c2af7f1","847":"d677bbbf"}[chunkId] + ".chunk.js";
};